// src/pages/Services.jsx
import { useEffect } from "react";
import SectionTitle from '../components/common/SectionTitle';
import ServiceCard from '../components/services/ServiceCard';
import service1 from '../Assets/Services/PD.webp'
import service2 from '../Assets/Services/GC.webp'
import service3 from '../Assets/Services/Endodontic.jpeg'
import service4 from '../Assets/Services/LD.webp'
import service5 from '../Assets/Services/C&B.webp'
import service6 from '../Assets/Services/Dentures.webp'
import service7 from '../Assets/Services/O&M.webp'
import service8 from '../Assets/Services/Orthodontics.webp'
import service9 from '../Assets/Services/Cosmetic Dentistry.webp'
import service10 from '../Assets/Services/dentalimplants.webp'

// You can keep this data in services.js or define here for demo

const serviceData = [
  {
    title: "Pediatric Dentistry",
    description: "Baby teeth set the foundation for permanent healthy teeth . It is important to keep the teeth clean and teach children to brush and floss.",
    image: service1,   // ← your real image path
    icon: "🦷",
    link: "/treatments/pediatric-dentistry"  
  },
  {
    title: "Gum Care",
    description: "Gum disease is the inflammation or infection that attacks the gums and bone that hold your teeth in place.",
    image: service2,
    icon: "🦷",
    link: "/treatments/gum-care"
  },
  {
    title: "Endodontic",
    description: "When a tooth become infected or damaged root canal treatment is often the only way to save your tooth and repair the damage.",
    image: service3,
    icon: "🦷",
    link: "/treatments/endodontic"
  },
  {
    title: "Laser Dentistry",
    description: "Introduced multipurpose laser first of its kind in India. Painless dentistry has entered a new era with Lasers.",
    image: service4,
    icon: "🦷",
    link: "/treatments/laser-dentistry"
  },
  {
    title: "Crowns & Bridges",
    description: "Crowns are used to cover teeth that are weakened by decay , severely damaged , chipped or discolored.",
    image: service5,
    icon: "🦷",
    link: "/treatments/crowns-and-bridges"
  },
  {
    title: "Dentures",
    description: "Dentures are sets of Artificial Teeth Set Into plastic frame works that rest directly on the gums.",
    image: service6,
    icon: "🦷",
    link: "/treatments/dentures"
  },
  {
    title: "Oral & Maxillofacial Surgery",
    description: "Oral surgery procedures such as Tooth extraction, impactions (wisdom/third molar teeth ), cyst removals, orthognathic surgery ( jaw repositioning )",
    image: service7,
    icon: "🦷",
    link: "/treatments/oral-maxillofacial-surgery"
  },
  {
    title: "Orthodontics",
    description: "Orthodontics refers to the use of wires to align crooked or crowded teeth and to close gaps between teeth.",
    image: service8,
    icon: "🦷",
    link: "/treatments/orthodontics"
  },
  {
    title: "Cosmetic Dentistry",
    description: "Bleaching is the simplest way to brighten your smile. Surface stains caused by food can be removed to reveal a glowing smile.",
    image: service9,
    icon: "🦷",
    link: "/treatments/cosmetic-dentistry"
  },
  {
    title: "Dental Implants",
    description: "Dental Implant is a surgical process to implant an artificial tooth root. These are biocompatible titanium roots placed into the jaw bone and allowed to slide with the bone over a span of a few months. The surgery helps gain support for a lost tooth/ teeth giving a natural look when you smile.",
    image: service10,
    icon: "🦷",
    link: "/treatments/dental-implants"
  },
  
  // add remaining services...
];

const Services = () => {
  useEffect(() => {
  window.scrollTo(0, 0);
}, []);
  return (
    <main className="pb-16 bg-gray-50">
      {/* Top banner / tag section */}
      <section className="bg-gradient-to-r from-blue-50 to-blue-100 py-12 md:py-16">
        <div className="container mx-auto px-6 text-center">
          <span className="text-xl inline-block bg-white text-blue-600 px-6 py-2 rounded-full font-medium mb-4 shadow-sm">
            Our Services
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-blue-900 mb-6">
            Services
          </h1>
          <p className="text-lg md:text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed">
          Our dental hospital offers complete oral healthcare services including preventive, cosmetic, and restorative treatments using the latest dental technology.

          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16 md:py-20">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
            {serviceData.map((service, index) => (
              <ServiceCard
                key={index}
                title={service.title}
                description={service.description}
                image={service.image}
                icon={service.icon}
                link={service.link}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Optional CTA at bottom */}
      <section className="bg-blue-600 text-white py-16 text-center">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Ready for a Healthier Smile?
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Schedule your consultation today and experience world-class dental care.
          </p>
          <a
            href="/book-appointment"
            className="inline-block bg-white text-blue-600 px-10 py-4 rounded-full text-lg font-bold hover:bg-gray-100 transition shadow-lg"
          >
            Book Appointment Now →
          </a>
        </div>
      </section>
    </main>
  );
};

export default Services;